import React from "react";
import { FileImageOutlined, FileOutlined } from "@ant-design/icons";
import { isImage } from "./allegatiUtils";

// Icona segnaposto per gli allegati senza thumbnail (non immagini o url mancante).
const FileTypeIcon = ({ mimeType, size = 24 }) => {
  const style = { fontSize: size };

  if (isImage(mimeType)) {
    return <FileImageOutlined style={{ ...style, color: "#52c41a" }} />;
  }

  return <FileOutlined style={style} />;
};

export default FileTypeIcon;
